import { COLORS } from '../../../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');
  const minSm = theme.breakpoints.up('sm');
  return {
    formRow: {
      width: '100%',
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '&:first-child': {
        marginTop: -20,
        [minMd]: {
          marginTop: -30,
        },
      },
    },
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    stateSelectContain: {
      display: 'flex',
    },
    formGroup: {
      width: '100%',
      marginTop: 20,
      [minMd]: {
        marginTop: 30,
      },
    },
    halfFormGroup: {
      width: '100%',
      [minSm]: {
        width: '48%',
      },
    },
    notificationDisclosure: {
      marginTop: 24,
      fontSize: '0.875rem',
      display: 'flex',
      lineHeight: 1.58,
      '& > div': {
        marginRight: 5,
      },
    },
    hidden: {
      display: 'none',
    },
  };
};

export default styles;
